import React, { useEffect } from "react";
const Calculator = () => {
  useEffect(() => {
    // Calculator JavaScript logic
    window.calculatorFunctions = {
      totalDigits: 12,
      pareSize: 12,
      degreeRadians: "degree",
      value: 0,
      memory: 0,
      level: 0,
      entered: true,
      decimal: 0,
      fixed: 0,
      exponent: false,
      digits: 0,
      showValue: "0",
      isShowValue: true,
      Hj: 0,
      uI: [],
      init() {
        function stackItem() {
          this.value = 0;
          this.op = "";
        }
        for (let i = 0; i < this.pareSize; i++) {
          this.uI[i] = new stackItem();
        }
      },
      format(I) {
        var E = "" + I;
        if (E.indexOf("N") >= 0 || (I == 2 * I && I == 1 + I)) {
          return "Error ";
        }
        var G = E.indexOf("e");
        if (G >= 0) {
          var A = E.substring(G + 1, E.length);
          if (G > 11) G = 11;
          E = E.substring(0, G);
          if (E.indexOf(".") < 0) {
            E += ".";
          } else {
            let j = E.length - 1;
            while (j >= 0 && E.charAt(j) == "0") --j;
            E = E.substring(0, j + 1);
          }
          E += " " + A;
        } else {
          var J = false;
          if (I < 0) {
            I = -I;
            J = true;
          }
          var C = Math.floor(I);
          var K = I - C;
          var D = this.totalDigits - ("" + C).length - 1;
          if (!this.entered && this.fixed > 0) {
            D = this.fixed;
          }
          var F = " 1000000000000000000".substring(1, D + 2) + "";
          if (F == "" || F == " ") {
            F = 1;
          } else {
            F = parseInt(F);
          }
          var B = Math.floor(K * F + 0.5);
          C = Math.floor(Math.floor(I * F + 0.5) / F);
          if (J) {
            E = "-" + C;
          } else {
            E = "" + C;
          }
          var H = "00000000000000" + B;
          H = H.substring(H.length - D, H.length);
          G = H.length - 1;
          if (this.entered || this.fixed == 0) {
            while (G >= 0 && H.charAt(G) == "0") --G;
            H = H.substring(0, G + 1);
          }
          if (G >= 0) {
            E += "." + H;
          }
        }
        return E;
      },
      refresh() {
        var A = this.format(this.value);
        if (this.exponent) {
          if (this.Hj < 0) {
            A += " " + this.Hj;
          } else {
            A += " +" + this.Hj;
          }
        }
        // Only show decimal point when actively typing decimal numbers
        if (!this.entered && this.decimal > 0 && A.indexOf(".") < 0 && A != "Error ") {
          A += ".";
        }
        const output = document.getElementById("sciOutPut");
        if (output) {
          output.innerHTML = A || "0";
        }
      },
      push(B, C, A) {
        if (this.level == this.pareSize) return false;
        for (let i = this.level; i > 0; --i) {
          this.uI[i].value = this.uI[i - 1].value;
          this.uI[i].op = this.uI[i - 1].op;
          this.uI[i].vg = this.uI[i - 1].vg;
        }
        this.uI[0].value = B;
        this.uI[0].op = C;
        this.uI[0].vg = A;
        ++this.level;
        return true;
      },
      pop() {
        if (this.level == 0) return false;
        for (let i = 0; i < this.level; ++i) {
          this.uI[i].value = this.uI[i + 1].value;
          this.uI[i].op = this.uI[i + 1].op;
          this.uI[i].vg = this.uI[i + 1].vg;
        }
        --this.level;
        return true;
      },
      evalx() {
        if (this.level == 0) return false;
        const op = this.uI[0].op;
        const Qk = this.uI[0].value;
        if (op == "+") {
          this.value = parseFloat(Qk) + this.value;
        } else if (op == "-") {
          this.value = Qk - this.value;
        } else if (op == "*") {
          this.value = Qk * this.value;
        } else if (op == "/") {
          this.value = Qk / this.value;
        } else if (op == "pow") {
          this.value = Math.pow(Qk, this.value);
        } else if (op == "apow") {
          this.value = Math.pow(Qk, 1 / this.value);
        }
        this.pop();
        if (op == "(") return false;
        return true;
      },
      enter() {
        if (this.exponent) {
          this.value = this.value * Math.exp(this.Hj * Math.LN10);
        }
        this.entered = true;
        this.exponent = false;
        this.decimal = 0;
        this.fixed = 0;
      },
      numInput(A) {
        if (this.entered) {
          this.value = 0;
          this.digits = 0;
          this.entered = false;
        }
        if (A == 0 && this.digits == 0) {
          this.refresh();
          return;
        }
        if (this.exponent) {
          if (this.Hj < 0) A = -A;
          if (this.digits < 3) {
            this.Hj = this.Hj * 10 + A;
            ++this.digits;
            this.refresh();
          }
          return;
        }
        if (this.value < 0) A = -A;
        if (this.digits < this.totalDigits - 1) {
          ++this.digits;
          if (this.decimal > 0) {
            this.decimal = this.decimal * 10;
            this.value = this.value + A / this.decimal;
            ++this.fixed;
          } else {
            this.value = this.value * 10 + A;
          }
        }
        this.refresh();
      },
      opt(A) {
        this.enter();
        let vg;
        if (A == "+" || A == "-") {
          vg = 1;
        } else if (A == "*" || A == "/") {
          vg = 2;
        } else if (A == "pow" || A == "apow") {
          vg = 3;
        }
        if (this.level > 0 && vg <= this.uI[0].vg) {
          this.evalx();
        }
        if (!this.push(this.value, A, vg)) {
          this.value = "NAN";
        }
        this.refresh();
      },
      func(D) {
        this.enter();
        if (D == "1/x") {
          this.value = 1 / this.value;
        } else if (D == "sqrt") {
          this.value = Math.sqrt(this.value);
        } else if (D == "MS") {
          this.memory = this.value;
        } else if (D == "M+") {
          this.memory += this.value;
        } else if (D == "M-") {
          this.memory -= this.value;
        } else if (D == "MR") {
          this.value = this.memory;
        } else if (D == "MC") {
          this.memory = 0;
        }
        this.refresh();
      },
      backspace() {
        if (this.entered || this.exponent) return;
        if (this.decimal > 0) {
          if (this.fixed > 0) {
            const multiplier = Math.pow(10, this.fixed);
            this.value = Math.floor(this.value * multiplier) / multiplier;
            this.decimal = this.decimal / 10;
            this.fixed--;
            if (this.fixed == 0) {
              this.decimal = 0;
            }
          }
        } else if (this.digits > 0) {
          if (this.value < 0) {
            this.value = -Math.floor(Math.abs(this.value) / 10);
          } else {
            this.value = Math.floor(this.value / 10);
          }
          this.digits--;
        }
        if (this.digits == 0 && this.decimal == 0) {
          this.value = 0;
          this.entered = false;
        }
        this.refresh();
      },
      r(A) {
        if (A == "⌫" || A == "BS") {
          this.backspace();
          return;
        }
        if (
          A == 1 || A == 2 || A == 3 || A == 4 || A == 5 ||
          A == 6 || A == 7 || A == 8 || A == 9 || A == 0
        ) {
          this.numInput(A);
        } else if (A == "+" || A == "-" || A == "*" || A == "/") {
          this.opt(A);
        } else if (A == ".") {
          if (this.entered) {
            this.value = 0;
            this.digits = 1;
          }
          this.entered = false;
          if (this.decimal == 0 && this.value == 0 && this.digits == 0) {
            this.digits = 1;
          }
          if (this.decimal == 0) {
            this.decimal = 1;
          }
          this.refresh();
        } else if (A == "+/-") {
          if (this.exponent) {
            this.Hj = -this.Hj;
          } else {
            this.value = -this.value;
          }
          this.refresh();
        } else if (A == "C") {
          this.level = 0;
          this.exponent = false;
          this.value = 0;
          this.enter();
          this.refresh();
        } else if (A == "=") {
          this.enter();
          while (this.level > 0) {
            this.evalx();
          }
          this.refresh();
        } else if (
          A == "sqrt" || A == "MS" || A == "M+" || A == "M-" ||
          A == "MR" || A == "MC" || A == "1/x"
        ) {
          this.func(A);
        }
      },
    };
    // Initialize
    window.calculatorFunctions.init();
    window.calculatorFunctions.refresh();
    // Cleanup
    return () => {
      delete window.calculatorFunctions;
    };
  }, []);
  const handleClick = (value) => {
    if (window.calculatorFunctions) {
      window.calculatorFunctions.r(value);
    }
  };
  return (
    <div style={{ width: "100%", maxWidth: "400px", margin: "0 auto" }}>
      <style>
        {`
    @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@300;400;500;700;900&family=IBM+Plex+Sans+Arabic:wght@300;400;500;600;700&display=swap');
    #sciout {
      padding: 20px;
      border: 2px solid #1a5f3f;
      border-radius: 16px;
      background: linear-gradient(135deg, #ffffff 0%, #f8fbf9 100%);
      font-family: 'IBM Plex Sans Arabic', 'Tajawal', arial, helvetica, sans-serif;
      box-shadow: 0 8px 25px rgba(26, 95, 63, 0.12);
      max-width: 380px;
      margin: 0 auto;
    }
    #sciOutPut {
      font-size: 32px;
      font-weight: 700;
      padding: 18px 20px;
      margin: 0 0 18px 0;
      cursor: text;
      text-align: right;
      background: linear-gradient(135deg, #1a5f3f 0%, #2d8a5f 100%);
      border: none;
      border-radius: 12px;
      color: #ffffff;
      min-height: 70px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      box-shadow: 0 4px 12px rgba(26, 95, 63, 0.25);
      font-family: 'Tajawal', monospace;
      letter-spacing: 1px;
    }
    .scinm {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      width: 62px;
      height: 62px;
      line-height: 62px;
      margin: 4px;
      border: 2px solid #1a5f3f;
      border-radius: 14px;
      font-family: 'Tajawal', arial, helvetica, sans-serif;
      font-size: 22px;
      font-weight: 700;
      color: #ffffff;
      background: linear-gradient(135deg, #1a5f3f 0%, #2d8a5f 100%);
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 4px 8px rgba(26, 95, 63, 0.2);
      user-select: none;
    }
    .scinm:hover {
      background: linear-gradient(135deg, #2d8a5f 0%, #3a9f6f 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(26, 95, 63, 0.3);
    }
    .scinm:active {
      background: linear-gradient(135deg, #0f3d28 0%, #1a5f3f 100%);
      transform: translateY(0);
      box-shadow: 0 2px 4px rgba(26, 95, 63, 0.3);
    }
    .sciop {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      width: 62px;
      height: 62px;
      line-height: 62px;
      margin: 4px;
      border: 2px solid #e2e8f0;
      border-radius: 14px;
      font-family: 'Tajawal', arial, helvetica, sans-serif;
      font-size: 22px;
      font-weight: 700;
      color: #1a5f3f;
      background: #ffffff;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
      user-select: none;
    }
    .sciop:hover {
      background: #f0f7f4;
      border-color: #1a5f3f;
      transform: translateY(-2px);
      box-shadow: 0 4px 10px rgba(26, 95, 63, 0.15);
    }
    .sciop:active {
      background: #1a5f3f;
      color: #ffffff;
      transform: translateY(0);
      box-shadow: 0 2px 4px rgba(26, 95, 63, 0.2);
    }
    .scieq {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      width: 62px;
      height: 62px;
      line-height: 62px;
      margin: 4px;
      border: 2px solid #d4af37;
      border-radius: 14px;
      font-family: 'Tajawal', arial, helvetica, sans-serif;
      font-size: 22px;
      font-weight: 700;
      color: #0f3d28;
      background: linear-gradient(135deg, #d4af37 0%, #f0d875 100%);
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 4px 8px rgba(212, 175, 55, 0.3);
      user-select: none;
    }
    .scieq:hover {
      background: linear-gradient(135deg, #f0d875 0%, #fae89e 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(212, 175, 55, 0.4);
    }
    .scieq:active {
      background: linear-gradient(135deg, #b89530 0%, #d4af37 100%);
      transform: translateY(0);
      box-shadow: 0 2px 4px rgba(212, 175, 55, 0.3);
    }
    .scibs {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      width: 62px;
      height: 62px;
      line-height: 62px;
      margin: 4px;
      border: 2px solid #dc3545;
      border-radius: 14px;
      font-family: 'Tajawal', arial, helvetica, sans-serif;
      font-size: 20px;
      font-weight: 700;
      color: #ffffff;
      background: linear-gradient(135deg, #dc3545 0%, #e85d6b 100%);
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
      user-select: none;
    }
    .scibs:hover {
      background: linear-gradient(135deg, #e85d6b 0%, #f28790 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(220, 53, 69, 0.4);
    }
    .scibs:active {
      background: linear-gradient(135deg, #bd2130 0%, #dc3545 100%);
      transform: translateY(0);
      box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
    }
    #calfootnote {
      font-family: 'IBM Plex Sans Arabic', 'Tajawal', arial, helvetica, sans-serif;
      font-size: 11px;
      text-align: center;
      margin-top: 12px;
      color: #6c757d;
      padding: 8px;
    }
    #calfootnote a {
      color: #1a5f3f;
      text-decoration: none;
      font-weight: 600;
    }
    #calfootnote a:hover {
      color: #2d8a5f;
      text-decoration: underline;
    }
    @media (max-width: 480px) {
      #sciout {
        padding: 15px;
        max-width: 100%;
        border-radius: 12px;
      }
      #sciOutPut {
        font-size: 26px;
        padding: 15px;
        min-height: 60px;
      }
      .scinm, .sciop, .scieq, .scibs {
        width: 56px;
        height: 56px;
        line-height: 56px;
        margin: 3px;
        font-size: 20px;
        border-radius: 12px;
      }
    }
    @media (max-width: 360px) {
      .scinm, .sciop, .scieq, .scibs {
        width: 50px;
        height: 50px;
        line-height: 50px;
        margin: 2px;
        font-size: 18px;
      }
      #sciOutPut {
        font-size: 22px;
      }
    }
  `}
      </style>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <tbody>
          <tr>
            <td id="sciout">
              <div>
                <div id="sciOutPut">0</div>
              </div>
              <div style={{ paddingTop: "5px" }}>
                <div style={{ textAlign: "center" }}>
                  <span onClick={() => handleClick(7)} className="scinm">7</span>
                  <span onClick={() => handleClick(8)} className="scinm">8</span>
                  <span onClick={() => handleClick(9)} className="scinm">9</span>
                  <span onClick={() => handleClick("/")} className="sciop">÷</span>
                  <span onClick={() => handleClick("⌫")} className="scibs">⌫</span>
                </div>
                <div style={{ textAlign: "center" }}>
                  <span onClick={() => handleClick(4)} className="scinm">4</span>
                  <span onClick={() => handleClick(5)} className="scinm">5</span>
                  <span onClick={() => handleClick(6)} className="scinm">6</span>
                  <span onClick={() => handleClick("*")} className="sciop">×</span>
                  <span onClick={() => handleClick("MC")} className="sciop">MC</span>
                </div>
                <div style={{ textAlign: "center" }}>
                  <span onClick={() => handleClick(1)} className="scinm">1</span>
                  <span onClick={() => handleClick(2)} className="scinm">2</span>
                  <span onClick={() => handleClick(3)} className="scinm">3</span>
                  <span onClick={() => handleClick("-")} className="sciop">−</span>
                  <span onClick={() => handleClick("MR")} className="sciop">MR</span>
                </div>
                <div style={{ textAlign: "center" }}>
                  <span onClick={() => handleClick(0)} className="scinm">0</span>
                  <span onClick={() => handleClick(".")} className="scinm">.</span>
                  <span onClick={() => handleClick("+")} className="sciop">+</span>
                  <span onClick={() => handleClick("C")} className="scieq">C</span>
                  <span onClick={() => handleClick("=")} className="scieq">=</span>
                </div>
                <div style={{ textAlign: "center" }}>
                  <span onClick={() => handleClick("+/-")} className="sciop">±</span>
                  <span onClick={() => handleClick("sqrt")} className="sciop">√x</span>
                  <span onClick={() => handleClick("MS")} className="sciop">MS</span>
                  <span onClick={() => handleClick("M+")} className="sciop">M+</span>
                  <span onClick={() => handleClick("M-")} className="sciop">M−</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default Calculator;